import React, { useEffect } from 'react';
import {api} from "../services";
import {useLocalization} from "../context/localization"; 

const DynamicFavicon = () => {
    const { language } = useLocalization();

    useEffect(() => {
        const fetchAndSetFavicon = async () => {
            try {
                const res = await api.general.getHeaderLogos(language);
                
                const logoPath = res?.data.data.attributes?.logo.data.attributes.url;
                const description = res?.data.data.attributes?.description;
                
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'shortcut icon';
                link.href = logoPath;
                document.title = `${description}`;

                document.getElementsByTagName('head')[0].appendChild(link);
            } catch (error) {
                console.error('Favicon güncellenirken hata oluştu:', error);
            }
        };

        fetchAndSetFavicon();
    }, [language]);

    return null; 
};

export default DynamicFavicon;
